"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStripeAppId = exports.getSalesforceAppId = void 0;

var _enviro = _interopRequireDefault(require("enviro"));

var getSalesforceAppId = function getSalesforceAppId() {
  return _enviro.default.isQa('settings-ui') ? 1160722 : 38577;
};

exports.getSalesforceAppId = getSalesforceAppId;

var getStripeAppId = function getStripeAppId() {
  return _enviro.default.isQa('settings-ui') ? 1162443 : 63044;
};

exports.getStripeAppId = getStripeAppId;